import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowLeft, Mail } from "lucide-react";
import Footer from "./Footer";

export default function Bedankt() {
  useEffect(() => {
    document.title = "Bedankt | Takomst fan Menaam";
    return () => {
      document.title = "Takomst fan Menaam | Nieuwe school & accommodaties in Menaam";
    };
  }, []);

  return (
    <div className="bg-[#FAF7F2] min-h-screen flex flex-col">
      <section className="relative flex-1 flex items-center justify-center bg-[#1A2E22] overflow-hidden py-28 px-5">
        <div
          aria-hidden="true"
          className="absolute -right-32 top-0 w-[40rem] h-[40rem] rounded-full bg-[#74C69D]/10 blur-3xl pointer-events-none"
        />
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative max-w-xl text-center"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#74C69D]/15 text-[#74C69D] mb-7">
            <CheckCircle2 size={40} />
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl font-black text-[#FAF7F2] mb-4">
            Tige tank!
          </h1>
          <p className="text-lg text-[#FAF7F2]/75 leading-relaxed mb-3">
            Bedankt voor je aanmelding. Je bent er nu bij betrokken — <span className="text-[#74C69D] font-semibold">mei elkoar, foar elkoar</span>.
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-[#74C69D] bg-[#74C69D]/10 border border-[#74C69D]/30 rounded-xl px-5 py-3 mt-6 mb-9">
            <Mail size={18} className="shrink-0" />
            <span>Je aanmelding is gelukt. We houden je op de hoogte van de toekomst van Menaam.</span>
          </div>
          <Link
            to="/"
            data-testid="bedankt-home-link"
            className="inline-flex items-center gap-2 font-bold text-sm px-7 py-3.5 rounded-full bg-[#74C69D] text-[#1A2E22] hover:bg-[#8fd4b0] transition-colors"
          >
            <ArrowLeft size={17} /> Terug naar de website
          </Link>
        </motion.div>
      </section>
      <Footer />
    </div>
  );
}
